/*----------------------------------
- SAVE WORKFLOW MOTION
- Decorative fake-data preview of search criteria becoming a reusable Radar.
----------------------------------*/

import Icon from '@/client/components/ui/icon/Icon';

/*----------------------------------
- CONTENT
----------------------------------*/

const SAVED_CRITERIA = [
    { key: 'word', label: 'One word' },
    { key: 'tld', label: '.com + .ai' },
    { key: 'price', label: '≤ $25k' },
    { key: 'history', label: 'Clean history' },
] as const;

/*----------------------------------
- COMPONENT
----------------------------------*/

const SaveWorkflowMotion = () => (
    <div aria-hidden="true" class="ud-workflow-save">
        <div class="ud-workflow-save__criteria-layer">
            {SAVED_CRITERIA.map((criterion, index) => (
                <span
                    key={criterion.key}
                    class={`ud-workflow-save__criteria ud-workflow-save__criteria--${criterion.key}`}
                    style={{ animationDelay: `${index * 0.16}s` }}
                >
                    <Icon name="filter" size={10} strokeWidth={2} />
                    {criterion.label}
                </span>
            ))}
        </div>

        <div class="ud-workflow-save__radar">
            <div class="ud-workflow-save__radar-header">
                <span class="ud-workflow-save__radar-icon">
                    <Icon name="radar" size={15} strokeWidth={2} />
                </span>
                <span class="ud-workflow-save__radar-copy">
                    <span class="ud-workflow-save__radar-name">Short &amp; liquid</span>
                    <span class="ud-workflow-save__radar-cadence">Radar · Daily digest</span>
                </span>
                <span class="ud-workflow-save__saved">
                    <Icon name="check" size={10} strokeWidth={2.3} />
                    Saved
                </span>
            </div>

            <div class="ud-workflow-save__logic">
                <span>.com + .ai</span>
                <span>≤ $25k</span>
                <span>One word</span>
            </div>

            <div class="ud-workflow-save__match">
                <span class="ud-workflow-save__match-dot" />
                <strong>3 new matches</strong>
                <span>today</span>
            </div>
        </div>
    </div>
);

export default SaveWorkflowMotion;
